import React from 'react'
import { Image, ImageProps } from 'react-bootstrap'
import ImgDefaultAvatar from 'entities/courses/media/img_default_avatar.png'

type Props = ImageProps
const Avatar = ({ src, ...rest }: Props) => <Image src={src || ImgDefaultAvatar} {...rest} />

export default Avatar
